import { render, staticRenderFns } from "./NavPagination.vue?vue&type=template&id=41faf8ec&"
import script from "./NavPagination.vue?vue&type=script&lang=js&"
export * from "./NavPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('41faf8ec')) {
      api.createRecord('41faf8ec', component.options)
    } else {
      api.reload('41faf8ec', component.options)
    }
    module.hot.accept("./NavPagination.vue?vue&type=template&id=41faf8ec&", function () {
      api.rerender('41faf8ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/vue/components/navigation/NavPagination.vue"
export default component.exports